import styles from './styles.module.scss';


const HeaderTab = ({ children }) => {
  const sidebarExpanded = true;

  return <div className={sidebarExpanded ? styles.tab_bar : styles.tab_bar_Big}>{children}</div>;
};

export default HeaderTab;
